import { useCallback } from 'react';
import { gate } from 'hub-http/gates';
import { sendCrossTabMessage } from 'calling-cross-tab-library/external/sendCrossTabMessage';
import { createOpenRemoteMessage } from 'calling-lifecycle-messages/deviceEventCreators';
import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
import devLogger from 'react-utils/devLogger';
import { useHttpClient } from '../../client/HttpClientContext';
import { getObjectLabel } from '../../utils/getObjectLabel';
import { Metrics } from '../../metrics/Metrics';
import { useGetIsUngated } from './useGetIsUngated';
import { useObjectId } from './useObjectId';
import { useObjectTypeId } from './useObjectTypeId';
import { usePropertyValue } from './usePropertyValue';
import { useGetAdditionalPropertyValue } from './useGetAdditionalPropertyValue';
export const useCallingMessage = () => {
  const getIsUngated = useGetIsUngated();
  const httpClient = useHttpClient();
  const propertyValue = usePropertyValue();
  const objectId = useObjectId();
  const objectTypeId = useObjectTypeId();
  const getAdditionalPropertyValue = useGetAdditionalPropertyValue();
  const isUngatedForCallingWidget = getIsUngated(gate('CRM:Properties:CallingWidget'));
  const canSendMessage = Boolean(propertyValue && objectId && objectTypeId && isUngatedForCallingWidget);
  const sendMessage = useCallback(async () => {
    if (!canSendMessage) {
      return;
    }
    try {
      const client = await getFrameworkDataSchemasClient({
        httpClient
      });
      const frameworkTypes = await client.frameworkTypes.getObjects();
      const objectType = frameworkTypes.find(type => type.objectTypeId === objectTypeId);
      const objectLabel = getObjectLabel(objectId, objectTypeId, objectType === null || objectType === void 0 ? void 0 : objectType.primaryDisplayLabelPropertyName, getAdditionalPropertyValue);
      await sendCrossTabMessage(createOpenRemoteMessage({
        callableObject: {
          phoneNumber: propertyValue || '',
          name: objectLabel,
          objectTypeId,
          objectId: parseInt(objectId || '0', 10)
        }
      }));
    } catch (error) {
      await sendCrossTabMessage(createOpenRemoteMessage({
        callableObject: {
          phoneNumber: propertyValue || '',
          name: '',
          objectTypeId,
          objectId: parseInt(objectId || '0', 10)
        }
      }));
      devLogger.warn({
        message: `useCallingMessage-call-initiation-failed: Failed to initiate call via sendCrossTabMessage for objectTypeId=${objectTypeId}, objectId=${objectId}, phoneNumber=${propertyValue}, error=${(error === null || error === void 0 ? void 0 : error.message) || 'Unknown error'}`,
        key: 'useCallingMessage-call-initiation-failed'
      });
      Metrics.counter('useCallingMessage-call-initiation-failure').increment();
    }
  }, [canSendMessage, propertyValue, objectTypeId, objectId, httpClient, getAdditionalPropertyValue]);
  return {
    canSendMessage,
    sendMessage
  };
};